
import { CourseSchedule } from '@/types';
import { supabase } from '../utils';
import { mapScheduleToModel } from './types';

export async function getScheduleById(scheduleId: string): Promise<CourseSchedule | null> {
  try {
    console.log(`Fetching schedule with ID "${scheduleId}" from Supabase...`);
    
    const scheduleIdNum = parseInt(scheduleId, 10);
    
    if (isNaN(scheduleIdNum)) {
      console.error('Invalid schedule ID format:', scheduleId);
      return null;
    }
    
    const { data, error } = await supabase
      .from('course_schedule')
      .select(`
        *,
        course:course_id (
          course_id,
          code,
          tech,
          category,
          course_description,
          days,
          price
        )
      `)
      .eq('schedule_id', scheduleIdNum)
      .maybeSingle();
      
    if (error) {
      console.error('Error fetching schedule:', error);
      return null;
    }
    
    console.log('Fetched schedule:', data);
    
    if (!data) {
      return null;
    }
    
    const startDate = new Date(data.start_date || '');
    const days = data.course?.days || 0;
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + days - 1);
    
    return mapScheduleToModel(data, startDate, endDate);
  } catch (error) {
    console.error('Error in getScheduleById:', error);
    return null;
  }
}
